import React, { useState } from "react";
import { Globe, Lightbulb, Calendar, ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";
import { VALUE_PROPOSITIONS } from "../../lib/constants";

const iconMap = {
  Globe,
  Lightbulb,
  Calendar,
};

export function ValueProp({ className }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section
      className={cn(
        "pt-2 pb-8 md:pt-4 md:pb-10 px-4",
        "bg-paper-dark/30",
        className
      )}
    >
      <div className="max-w-6xl mx-auto">
        {/* Collapsible Header */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={cn(
            "w-full group cursor-pointer",
            "flex items-center justify-center gap-3",
            "py-4 px-6 rounded-sm",
            "transition-all duration-300",
            "hover:bg-paper-dark/50"
          )}
          aria-expanded={isExpanded}
        >
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-ink tracking-tight">
            Why Subscribe?
          </h2>
          <ChevronDown
            className={cn(
              "w-6 h-6 text-gold transition-transform duration-300",
              isExpanded && "rotate-180"
            )}
          />
        </button>

        {/* Expandable Content */}
        <div
          className={cn(
            "overflow-hidden transition-all duration-500 ease-out",
            isExpanded ? "max-h-[800px] opacity-100 mt-8" : "max-h-0 opacity-0 mt-0"
          )}
        >
          {/* Subtitle */}
          <p className="text-center text-ink-muted font-body text-lg max-w-2xl mx-auto mb-10">
            Join other mining professionals who rely on The Arabian-Nubian Brief for critical market intelligence.
          </p>

          {/* 3-Column Grid - Newspaper Style */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 lg:gap-10">
            {VALUE_PROPOSITIONS.map((prop, index) => {
              const Icon = iconMap[prop.icon];
              return (
                <article
                  key={prop.title}
                  className={cn(
                    "text-center md:text-left",
                    // Newspaper column dividers on desktop
                    index < VALUE_PROPOSITIONS.length - 1 &&
                      "md:border-r md:border-border md:pr-6 lg:pr-10"
                  )}
                >
                  {/* Icon */}
                  <div className="flex justify-center md:justify-start mb-4">
                    <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center">
                      {Icon && <Icon className="w-7 h-7 text-gold" />}
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="font-serif text-xl font-bold text-ink mb-3">
                    {prop.title}
                  </h3>

                  {/* Description */}
                  <p className="font-body text-ink-secondary leading-relaxed">
                    {prop.description}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
